module.exports = __webpack_public_path__ + "img/Transit Lane How.a98e8421.jpg";